import React, { createContext, useState, ReactElement, FC, useMemo, useCallback } from "react";
import languages from "../assets/languages/index"
import { ZodError } from "zod";

type objectType = {
  [key: string]: string
}


type LanguageContextType = {
  language: string,
  setLanguage: (languageCode: "sv" | "en") => void,
  tZod: (error: ZodError) => ZodError,
  t: (path: string, args?: objectType, fallback?: string) => string,
  theme: "light" | "dark",
  setTheme: (theme?:"light" | "dark") => void,
}

type Props = {
  children: ReactElement
}

const LanguageContext = createContext<LanguageContextType>({} as LanguageContextType);

export const LanguageProvider: FC<Props> = ({ children }) => {
  // get cookies and get language,  

  const [language, setLang] = useState(localStorage.language ?? navigator.language?.substring(0,2) ?? "en");
  const [theme, set_Theme] = useState<"light" | "dark">(localStorage.theme ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark":"light"));

  const [ langObject, setLangObject ] = useState(languages[localStorage.language ?? navigator.language?.substring(0,2) ?? "en"])

  const setTheme = useCallback((theme: "dark" | "light" | undefined | "") => {
    let t
    if(theme === undefined){
      t = localStorage.theme ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark":"light")
    }else if (theme === ""){
      localStorage.removeItem("theme")
      t = (window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark":"light")
    }
    else t = theme
    
    if(t === "dark") document.documentElement.classList.add("dark")
    else document.documentElement.classList.remove("dark")

    if(theme !== undefined && theme !== "") localStorage.theme = t
    set_Theme(t);
  }, [])

  const setLanguage = useCallback((languageCode: "sv" | "en") => {
    localStorage.language = languageCode
    setLangObject(languages[languageCode])
    setLang(languageCode)
  }, [])

  const t = useCallback((path: string | undefined, args?: objectType, fallback?: string):string => {
    try {
      if (!path) return ''
      let message:any = langObject;
      path.split('.').forEach((prop) => {message = message[prop]})

      if (args && message)
        Object.keys(args).forEach((p: any) => {
          message = message.replaceAll(new RegExp('\\$\\{' + p + '\\}', 'g'), args[p])
        })

      if(!message) console.warn(`Missing translation for "${path}"`)

      return message ?? fallback ?? `Missing translation for ${path}`
    } catch (e) {
      console.warn(`Missing translation for ${path}`, e)
      return fallback ?? `Missing translation for ${path}`
    }
  }, [langObject])

  const tZod = useCallback((error: ZodError) => {
    error.errors.map((e: any) => {
      const args = {
        max: e.maximum,
        min: e.minimum,
      }
      const fallback = e.message
      
      if (!e.message.startsWith('validation')) e.message = 'validation.'+e.message
      e.message = t(e.message, args, fallback)
      return e
    })
    
    return error
  }, [t])  

  const contextValue = useMemo(() => ({
    t,
    tZod,
    setLanguage,
    language,
    theme,
    setTheme
  }), [language, theme, langObject, setLang, t, tZod])

  if(!language) return <div>Loading language</div>

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageContext;
